import React, { useState } from 'react'
import './style.css'

// API documents
const API_URL = 'https://api.openweathermap.org/data/2.5/weather?q='
const API_KEY = '&units=metric&appid=fe3160c63978e72af38ed11c0b655a39'

function App() {

  const [inputCity, setInputCity] = useState("");
  const [weather, setWeather] = useState([]);

  function fetchAPI() {
    fetch(`${API_URL}${inputCity}${API_KEY}`)
    .then(res => res.json())
    .then(result => {
      setWeather(result);
      setInputCity('');
    });
  }

  const searchWeather = (e) => {
    if(e.key === "Enter") {
      fetchAPI();
    }
  }

  const searchWeatherBtn = () => {
    fetchAPI();
  }

  return (
    <div className={
      (typeof weather.main != "undefined") ? 
        ((weather.main.temp < 19 && weather.main.temp >= 13) ? 
          'app' 
          : (weather.main.temp < 13) ? 'app cold' : 'app hot') 
      : 'app'}>
      <main>
        <div className="box-input">
          <input 
          type="text" 
          placeholder="Search..." 
          onChange={e => setInputCity(e.target.value)}
          value={inputCity}
          onKeyPress={searchWeather}
          />
          <button className='btn-search' onClick={searchWeatherBtn}>SEARCH</button>
        </div>
        {(typeof weather.main != "undefined") ? (
          <div className="box-result">
            <h1 className='place'>{weather.name}, {weather.sys.country}</h1>
            <h1 className='temperature'>{Math.round(weather.main.temp)}°C</h1>
            <h1 className='weather'>{weather.weather[0].main}</h1>
          </div>
        ) : (
          <div className='box-noweather'>
            <h1>Welcome!</h1>
            <h1>Inserire una città valida...</h1>
          </div>
        )}
        

      </main>
    </div>
  )
}

export default App
